import React, { useState, useEffect, forwardRef } from 'react'
import Reusabletable from './EditableReportTable'
import { getClients, uploadClientMasterFile, updateClientById, deleteClientById, submitForm, clinetMasterSingleDataInput, multiDeleteClientMasterFile } from './../../../../services/global_redux/globale_actions/Client.action';
import { getStates } from "./../../../../services/global_redux/globale_actions/States.action";
import { useDispatch, useSelector } from 'react-redux';
import files from "./../../../../assets/templates/global_template/Org_Details.xlsx"
import List from '@mui/material/List';
import Multiselect from 'multiselect-react-dropdown';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Slide from '@mui/material/Slide';
import { useParams } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import { Modal } from 'react-bootstrap';
import into_icon from "../../../../assets/global_assets/create_data_imgs/into_icon.png"
import {
    HiOutlineIdentification,
    HiOutlineOfficeBuilding,
    HiOutlineGlobeAlt,
    HiOutlineLocationMarker,
    HiOutlineBriefcase,
    HiOutlineUser,
    HiOutlineDocumentText,
    HiOutlineHashtag,
    HiOutlinePhone,
    HiOutlineMail,
    HiOutlineCollection,
    HiOutlineUserCircle,
    HiOutlineUsers,
    HiOutlineUserGroup,
    HiOutlineCalendar,
    HiOutlineClock,
    HiOutlinePause,
    HiOutlineCurrencyRupee,
    HiOutlineSun,
    HiOutlinePencil,
    HiOutlineShieldCheck,
    HiOutlineLibrary,
} from "react-icons/hi";
import Select, { components } from 'react-select';
import { getUserRole } from './../../../../services/global_redux/globale_actions/Role.action';
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function ClientForm({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const [activeForm, setActiveForm] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [data, setData] = useState([]);
    const [openeditalert, setOpeneditalert] = useState(false);
    const [opendeletealert, setopendeletealert] = useState(false);
    const [deleteclientid, setdeleteclientid] = useState(null);
    const [openaddsingle, setOpenaddsingle] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [checkedItemCount, setCheckedItemCount] = useState(0);
    const [order, setorder] = useState('ASC');
    const [statedata, setstate] = useState([]);
    const tableName = "ClientTable";
    const [selectedOptions, setSelectedOptions] = useState([]);
    const dispatch = useDispatch();
    const { date } = useParams();
    const initialClientDataInput = {
        client_id: "",
        client_name: "",
        state_name: "",
        No_of_Branchs: "",
        Address: "",
        Headcount_Male: "",
        Headcount_Female: "",
        Headcount_Transgender: "",
        NatureOfWork: "",
        Name_of_Employer: "",
        pan_or_tan_of_the_employer: "",
        lin: "",
        Telephone_No: "",
        Email_ID: "",
        Date_of_Incorporation: "",
        WorkingHours: "",
        BreakTime: "",
        WeeklyHoliday: "",
        SalaryDate: "",
        AuthorisedSignatory: null,
        Authorised_Seal: null,
        Total_holidays: null,
    };
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkDelete, setCheckDelete] = useState(false); 
    const [formData, setFormData] = useState(initialClientDataInput);
      
    const header = [
        { key: "client_id", value: "Organization ID", input: "text" ,readOnly:true, Icon: HiOutlineIdentification},
        { key: "client_name", value: "Organization Name", input: "text" ,readOnly:true, Icon: HiOutlineOfficeBuilding},
        { key: "state_name", value: "State Name", input: "text", Icon: HiOutlineGlobeAlt },
        { key: "Address", value: "Address", input: "text", Icon: HiOutlineLocationMarker },
        { key: "NatureOfWork", value: "Nature Of Work",input:"text", Icon: HiOutlineBriefcase },
        { key: "Name_of_Employer", value: "Name of Employer",input:"text", Icon: HiOutlineUser },
        { key: "pan_or_tan_of_the_employer", value: "PAN or TAN of the Employer", input:"text", Icon: HiOutlineDocumentText},
        { key: "lin", value: "Labour Identification Number (LIN)", input:"text", Icon: HiOutlineHashtag},
        { key: "Telephone_No", value: "Telephone No",input:"text", Icon: HiOutlinePhone },
        { key: "Email_ID", value: "Email ID", input:"email", Icon: HiOutlineMail },
        { key: "No_of_Branchs", value: "No of Branches", input: "number",readOnly:true, Icon: HiOutlineCollection },
        { key: "Headcount_Male", value: "Headcount  Male", input: "number" ,readOnly:true, Icon: HiOutlineUserCircle },
        { key: "Headcount_Female", value: "Headcount Female", input: "number" ,readOnly:true, Icon: HiOutlineUsers },
        { key: "Headcount_Transgender", value: "Headcount Transgender", input: "number" ,readOnly:true, Icon: HiOutlineUserGroup },
        { key: "Date_of_Incorporation", value: "Date of Incorporation",input:"date", Icon: HiOutlineCalendar },
        { key: "WorkingHours", value: "Working Hours", input: "text", Icon: HiOutlineClock },
        { key: "BreakTime", value: "Break Time",input:"text", Icon: HiOutlinePause },
        { key: "SalaryDate", value: "Salary Date", input: "text", Icon: HiOutlineCurrencyRupee },
        { key: "WeeklyHoliday", value: "Weekly Holiday", input:"text", Icon: HiOutlineSun },
        { key: "AuthorisedSignatory", value: "Authorised Signatory",input:"file", Icon: HiOutlinePencil },
        { key: "Authorised_Seal", value: "Authorised Seal",input:"file", Icon: HiOutlineShieldCheck },
        // { key: "Total_holidays", value: "Total Holidays" ,input:"file"},

    ]
    const [actionChecked, setActionChecked] = useState("");
    
    const excludedKeyToCreate = [
    "No_of_Branchs",
    "Headcount_Male",
    "Headcount_Female",
    "Headcount_Transgender"
    ];
    // const daysoptions = [
    //     { key: 'Sunday', value: '6' },
    //     { key: 'Monday', value: '0' },
    //     { key: 'Tuesday', value: '1' },
    //     { key: 'Wednesday', value: '2' },
    //     { key: 'Thursday', value: '3' },
    //     { key: 'Friday', value: '4' },
    //     { key: 'saturday', value: '5' },
    // ];
    const daysoptions = [
        { value: "1", key: "Sunday" },
        { value: "2", key: "Monday" },
        { value: "3", key: "Tuesday" },
        { value: "4", key: "Wednesday" },
        { value: "5", key: "Thursday" },
        { value: "6", key: "Friday" },
        { value: "7", key: "Saturday" },
      ];
    const fetchdata = async () => {
        setLoading(true);
        try {
            const response = await dispatch(getClients(date));
            if (response.data) {
                setGetData(response.data);
                setLoading(false);
            } else {
                setGetData([]);
                setLoading(false);
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
            setLoading(false);
        }
    }
    const fetchState = async () => {
        try {
            const response = await dispatch(getStates());
            setstate(response.data.states);
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    }
    useEffect(() => {
        fetchState();
        fetchdata();
    }, [dispatch]);


    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadClientMasterFile(file));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'client_master_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadClientMasterFile(file));
        console.log("Upload client master response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            
            setActionChecked("create");
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};



    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteClientMasterFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {

        let salaryDate;
        if(typeof editedValues.SalaryDate === String){
            salaryDate = editedValues.SalaryDate?.trim();
        }
        else{
            salaryDate = editedValues.SalaryDate;
        }
        const salaryRegex = /^(?:[1-9]|[12][0-9]|3[01])$/;
        if (!salaryDate) {
            showSnackbar("Salary Date cannot be empty","warning");
            return;
        }
        if (salaryDate && !salaryRegex.test(salaryDate)){
            showSnackbar("Salary date must be a number between 1 and 31 (e.g., 1, 2, 3). Leading zeros (01, 02) and values above 31 are not allowed.", "warning");            return;
        }
        const telNo = editedValues.Telephone_No;
        const telRegex = /^[0-9-]+$/;

        if (telNo && !telRegex.test(telNo)){
            showSnackbar("Telephone number can contain only digits, spaces, parentheses (), and hyphens (-). are allowed.","warning");
            return;
        }

        const email = editedValues.Email_ID?.trim();
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

        if (email && !emailRegex.test(email)){
            showSnackbar("Enter a valid email address (e.g., user@example.com)","warning");
            return;
        }

        const workingHours = editedValues.WorkingHours?.trim();
        const workRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)\s?,\s?(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/i;
        const breakTime = editedValues.BreakTime?.trim();

        if (!breakTime){
            showSnackbar("Break Time cannot be empty","warning");
            return;
        }
        else if (breakTime && !workRegex.test(breakTime)){
            showSnackbar("Break Time must be in format like 01:30 PM or 02:30 PM","warning");
            return;
        }
        if (!workingHours){
            showSnackbar("Working hours cannot be empty","warning");
            return
        }
        else if (workingHours && !workRegex.test(workingHours)){
            showSnackbar("Working hours must be in format like 06:30 AM or 9:30 PM","warning");
            return;
        }
        const WeeklyHoliday = editedValues.WeeklyHoliday?.trim();
        if (!WeeklyHoliday) {
            showSnackbar("Weekly Holiday cannot be empty","warning");
            return;
        }
        setLoading(true);
        try {
            const response = await dispatch(updateClientById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteClientById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, valueObj]) => {
                formDataToSend.append(key, valueObj.value);
        });
        console.log("formData ",formData.client_id);
        
        const clientRegex = /^[A-Za-z0-9_]$/;
        const clientId = formData.client_id?.trim()
        console.log("clientsssss ", clientId);

        console.log("clientRegex.test(clientId)",clientRegex.test(clientId));
        
        
        if (!clientRegex.test(clientId)){
            showSnackbar("Enter a valid Organization ID","warning");
            return;
        }
        try {
            const response = await dispatch(clinetMasterSingleDataInput(formData));

            if (response && response.success) {
                setLoading(false);
                showSnackbar('Organization Created successfully!', 'success');
                addsinglehandleClose();
                setFormData(initialClientDataInput);
                fetchdata();
                setActionChecked("create");
            } else {
                setLoading(false);
                showSnackbar(`Failed to add Org ID: ${response.message || 'Unknown error'}`, 'error');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error adding client:', error.message);
            showSnackbar(`Failed to add Org ID: ${error.message}`, 'error');
        }
    };
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        const trimmedValue = value.replace(/^\s+/, "");
        setFormData((prev) => ({
            ...prev,
            [name]:  files ? files[0] : trimmedValue
          }));
      };
      
const handleKeyDown = (e) => {
    if (e.key === " " && e.target.value.length === 0) {
      e.preventDefault();
    }
  };

    const handleFormToggle = (form) => {
        setIsFormOpen(true);
    };
    const handleFormToggleSingleDataEntry = (form) => {
        setActiveForm(form)
        if (form == "AddSingleclient") {
            addsinglehandleClickOpen();
        }
        setIsFormOpen(true);
    };
    const addsinglehandleClickOpen = () => {
        setOpenaddsingle(true);
    };
    const addsinglehandleClose = () => {
        setOpenaddsingle(false);
        setIsFormOpen(false);
        setActiveForm(null);
    };
    const handleCloseeditalert = () => {
        setOpeneditalert(false);
    };
    const handledeleteClosealert = () => {
        setopendeletealert(false);
    };
    const MultiValueContainer = ({ getValue }) => {
        const selected = getValue().map((v) => v.label).join(", ");
        return <div style={{ color: "black", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selected}</div>;
      };
      
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
                const rawPermissions = response?.data?.permissions;
                const parsedPermissions = typeof rawPermissions === "string"
                    ? JSON.parse(rawPermissions)
                    : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
                parsedPermissions.forEach((item) => {
                  if (item.section == "Configuration" && item.module == "Org Details") {
                        setCheckCreate(item.action.create);
                        setCheckEdit(item.action.edit);
                        setCheckDelete(item.action.delete);
                    }
                })
    
        } catch (err) {
          console.error("Failed to fetch states:", err);
        }

    };
    useEffect(() => {
      getUserPermission();
    }, [dispatch]);
    return (
        <div className='container-fluid '>
            {checkCreate &&
                <ImportFileform
                setFiledata ={setFile}
                title={'Org. Details'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                File={file}        
                />
            }
        <EditableTable
        
        header={header}
        MainIcon={HiOutlineLibrary}
        title={'Org. Details'}
        data={getData}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {checkEdit}
        getDeletePermission = {checkDelete}
        date={date}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
            <>
                {checkCreate &&
                <button
                onClick={addsinglehandleClickOpen}
                >Create Org.</button>
                }
            </>
        }
        />

            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Org Details'}
                filestemp={filess}
                setLoading={setLoading}
                showSnackbar={showSnackbar}
                date={date}
                handleFormToggleSingleDataEntry={handleFormToggleSingleDataEntry}
            /> */}
            <Dialog
                open={openeditalert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to edit this Client? Any unsaved changes might be lost.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseeditalert}>No</Button>
                    <Button onClick={handleSaveClick}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={opendeletealert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete this Client? This action cannot be undone.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handledeleteClosealert}>No</Button>
                    <Button onClick={handledeleteClickOpenalert}>Yes</Button>
                </DialogActions>
            </Dialog>
    <Modal 
      show={openaddsingle} 
      onHide={addsinglehandleClose} 
      centered 
      dialogClassName="custom-modal-dialog"
      backdrop="static"
      keyboard={false}
      style={{ zIndex: "9999" }}
      className='bg-transparent'
    >
    <div className="row d-flex justify-content-center align-items-center w-100 bg-transparent " style={{ marginTop:"10px" }}>
      <div className="bg-white createUnitTableMainContainer text-white " style={{ minWidth: "70vw" ,padding:"5px",borderRadius:"10px",overflow:"auto",marginLeft:"20px"}}>
      <div className="row  rounded  p-0 m-0">
          <div className="col-md-12">
          <div className="row">
            <div className="close-btn-div sticky-top">
                <button type="button" className=" float-end bg-light  " onClick={addsinglehandleClose} aria-label="Close"><img src={into_icon} alt="" /></button>
            </div>
            </div>
            <div className="row px-3">
                <div className="card-body-changes">
                    <form onSubmit={handleSubmit}>
                        <div className="col-md-12">
                            <div className="row">
                            {header.map((item) => (
                                    !excludedKeyToCreate.includes(item.key)  && (
                                        <div className="col-md-3 mb-3" key={item.key}>
                                        <label htmlFor={item.key}>
                                            <b>
                                            {item.value}
                                            <span className="text-danger">*</span>
                                            </b>
                                        </label>

                                        {/* File input */}
                                        {item.input === "file" ? (
                                            <input
                                            type="file"
                                            className="form-control mt-1"
                                            id={item.key}
                                            name={item.key}
                                            onChange={handleChange}
                                            onKeyDown={handleKeyDown}
                                            accept={item.key === "Total_holidays" ? ".xls,.xlsx" : "image/*"}
                                            required
                                            />

                                        // Dropdown for State
                                        ) : item.key === "state_name" ? (
                                            <select
                                            className="form-control mt-1"
                                            id={item.key}
                                            name={item.key}
                                            value={formData[item.key] || ""}
                                            onChange={handleChange}
                                            onKeyDown={handleKeyDown}
                                            required
                                            >
                                            <option value="">--Select--</option>
                                            {statedata ? (
                                                statedata.map((item) => (
                                                    <option key={item.state_name} value={item.state_name}>
                                                        {item.state_name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="">No states available</option>
                                            )}
                                            </select>

                                        ) : item.key === "WeeklyHoliday" ? (
                                            <Select
                                                options={daysoptions.map(d => ({ value: d.value, label: d.key }))}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                isSearchable={true}
                                                components={{
                                                    MultiValue: () => null, // hide pills
                                                    ValueContainer: (props) => (
                                                    <components.ValueContainer {...props}>
                                                        <MultiValueContainer getValue={props.getValue} />
                                                    </components.ValueContainer>
                                                    ),
                                                }}
                                                styles={{
                                                    control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "35px",
                                                    height: "35px",
                                                    fontSize: "14px",
                                                    }),
                                                    menu: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "100px",
                                                    overflow: "auto",
                                                    }),
                                                    option: (provided, state) => ({
                                                    ...provided,
                                                    color: "black",
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                    cursor: "pointer",
                                                    }),
                                                }}
                                                onChange={(selected) => {
                                                    const values = selected.map((s) => s.value);
                                                    setFormData({
                                                    ...formData,
                                                    WeeklyHoliday: values.join(","),
                                                    });
                                                }}
                                                
                                                
                                                value={daysoptions
                                                    .map(d => ({ value: d.value, label: d.key }))
                                                    .filter(opt =>
                                                    formData.WeeklyHoliday
                                                        ?.split(",")
                                                        .map(v => v.trim())
                                                        .includes(opt.value)
                                                    )}
                                                
                                                placeholder="Select options"
                                                />
                                        ) : (
                                            <input
                                            type={item.input}
                                            className="form-control mt-1"
                                            id={item.key}
                                            name={item.key}
                                            value={formData[item.key] || ""}
                                            onChange={handleChange}
                                            onKeyDown={handleKeyDown}
                                            required
                                            {...(item.input === "number" ? { min: 0 } : {})}
                                            />
                                        )}
                                        </div>

                            )))}
                            </div>
                        </div>

                        <div className="col-md-12 pe-3 mb-5 pb-2">
                            <div className="row float-end">
                            <button className="btn btn-md btn-success me-3" type="submit">
                                <b>Submit</b>
                            </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
          </div>
          </div>
        </div>
        </div>
        <div className="color-dark">
        </div>
    </Modal>
        </div>
    )
}

export default ClientForm














